<!--suppress JSUnresolvedVariable -->
<template>
  <div class="mt-4 ml-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">首页内容管理</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-4 mx-1">
      <el-table
        ref="multipleTable"
        :data="indexParts"
        tooltip-effect="dark"
        style="width: 100%;min-height: 500px"
        stripe
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column prop="partId" label="模块ID" sortable align="center">
        </el-table-column>
        <el-table-column prop="partName" label="模块名称" align="center">
        </el-table-column>
        <el-table-column label="模块状态" sortable align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.state"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="显示"
              inactive-text="隐藏"
              :active-value="1"
              :inactive-value="0"
              @change="value => indexPartStatusChange(value, scope.row.partId)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="editNavigation(scope.row.partId)"
              type="primary"
              plain
              size="small"
              icon="el-icon-edit"
              >编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "IndexPartList",
  data() {
    return {
      indexParts: [],
      loading: false
    };
  },
  mounted() {
    this.getPartList();
  },
  methods: {
    getPartList() {
      this.loading = true;
      this.axios.get("/indexPart/getPartList").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.indexParts = resp.data.data;
          this.loading = false;
        }
      });
    },
    editNavigation(partId) {
      this.$router
        .push({ name: "EditIndexPart", params: { partId: partId } })
        .catch();
    },
    indexPartStatusChange(value, partId) {
      this.axios
        .post("/indexPart/updateById", {
          partId: partId,
          state: value
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (value) {
              this.$notify({
                title: "操作成功",
                message: "模块已显示！",
                type: "success"
              });
            } else {
              this.$notify({
                title: "操作成功",
                message: "模块已隐藏！",
                type: "success"
              });
            }
          }
        });
    }
  }
};
</script>

<style scoped></style>
